<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content></div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">No</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
</div>
